import React from "react";
import { cn } from "../../utils/cn";

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?:
    | "default"
    | "secondary"
    | "outline"
    | "destructive"
    | "success"
    | "warning"
    | "info"
    | "purple";
  size?: "sm" | "md" | "lg";
  dot?: boolean;
}

const Badge: React.FC<BadgeProps> = ({
  variant = "default",
  size = "md",
  dot = false,
  className,
  children,
  ...props
}) => {
  const baseClasses = "inline-flex items-center font-medium rounded-full";

  const sizeClasses = {
    sm: "px-2 py-0.5 text-xs",
    md: "px-2.5 py-0.5 text-xs",
    lg: "px-3 py-1 text-sm",
  };

  const variantClasses = {
    default: "bg-blue-100 text-blue-800",
    secondary: "bg-gray-100 text-gray-800",
    outline: "border border-purple-300 text-gray-700 bg-transparent",
    destructive: "bg-red-100 text-red-800",
    success: "bg-green-100 text-green-800",
    warning: "bg-yellow-100 text-yellow-800",
    info: "bg-blue-100 text-blue-800",
    purple: "bg-purple-100 text-purple-800",
  };

  return (
    <span
      className={cn(
        baseClasses,
        sizeClasses[size],
        variantClasses[variant],
        className,
      )}
      {...props}
    >
      {dot && (
        <span
          className={cn(
            "w-1.5 h-1.5 rounded-full mr-1.5",
            variant === "default" || variant === "info"
              ? "bg-blue-600"
              : variant === "secondary"
                ? "bg-gray-600"
                : variant === "destructive"
                  ? "bg-red-600"
                  : variant === "success"
                    ? "bg-green-600"
                    : variant === "warning"
                      ? "bg-yellow-600"
                      : variant === "purple"
                        ? "bg-purple-600"
                        : "bg-gray-600",
          )}
        />
      )}
      {children}
    </span>
  );
};

export default Badge;
export { Badge };
